import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendOpsOrderToPickingMutationVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.OpsOrderFilter>;
  ids?: Types.InputMaybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>;
}>;


export type SendOpsOrderToPickingMutation = { __typename?: 'Mutation', sendOpsOrderToPicking: { __typename?: 'SendToPickingResult', has_errors: boolean } };


export const SendOpsOrderToPickingDocument = gql`
    mutation SendOpsOrderToPicking($filter: OpsOrderFilter, $ids: [ID!]) {
  sendOpsOrderToPicking(filter: $filter, ids: $ids) {
    has_errors
  }
}
    `;
export type SendOpsOrderToPickingMutationFn = Apollo.MutationFunction<SendOpsOrderToPickingMutation, SendOpsOrderToPickingMutationVariables>;

/**
 * __useSendOpsOrderToPickingMutation__
 *
 * To run a mutation, you first call `useSendOpsOrderToPickingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOpsOrderToPickingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOpsOrderToPickingMutation, { data, loading, error }] = useSendOpsOrderToPickingMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSendOpsOrderToPickingMutation(baseOptions?: Apollo.MutationHookOptions<SendOpsOrderToPickingMutation, SendOpsOrderToPickingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOpsOrderToPickingMutation, SendOpsOrderToPickingMutationVariables>(SendOpsOrderToPickingDocument, options);
      }
export type SendOpsOrderToPickingMutationHookResult = ReturnType<typeof useSendOpsOrderToPickingMutation>;
export type SendOpsOrderToPickingMutationResult = Apollo.MutationResult<SendOpsOrderToPickingMutation>;
export type SendOpsOrderToPickingMutationOptions = Apollo.BaseMutationOptions<SendOpsOrderToPickingMutation, SendOpsOrderToPickingMutationVariables>;